/**
 * Mapbox API constants and configuration
 */

/**
 * Mapbox API base URLs
 */
export const MAPBOX_API = {
  DIRECTIONS: 'https://api.mapbox.com/directions/v5/mapbox',
  SEARCH_SUGGEST: 'https://api.mapbox.com/search/searchbox/v1/suggest',
  SEARCH_RETRIEVE: 'https://api.mapbox.com/search/searchbox/v1/retrieve',
  GEOCODING: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
} as const;

/**
 * Default search feature types for Search Box API
 */
export const DEFAULT_SEARCH_TYPES = [
  'country',
  'region',
  'district',
  'postcode',
  'locality',
  'place',
  'neighborhood',
  'address',
  'poi',
  'street',
] as const;

/**
 * Feature types to exclude from search suggestions
 */
export const EXCLUDED_SEARCH_FEATURE_TYPES = ['category'] as const;

/**
 * Default configuration for API requests
 */
export const MAPBOX_CONFIG = {
  DEFAULT_SEARCH_LIMIT: 10,
  DEFAULT_DEBOUNCE_MS: 200,
  MIN_QUERY_LENGTH: 1,
} as const;

/**
 * Get Mapbox access token from environment
 */
export function getMapboxAccessToken(): string {
  const token = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN as string;
  if (!token) {
    throw new Error('VITE_MAPBOX_ACCESS_TOKEN is not defined in environment variables');
  }
  return token;
}
